import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { useLanguage } from '../i18n/LanguageContext.jsx';
import { routeForPageId } from '../layouts/menuData.js';

const SIGN_IN_PAGE_ID = 73933;

/**
 * Deny-by-default route gate: anonymous users are sent to Sign In (remembering the destination),
 * signed-in users without one of the allowed roles are sent to the 403 page.
 *
 *   <Route element={<RoleRoute roles={['admin']} />}> ... </Route>
 */
export default function RoleRoute({ roles }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const { t } = useLanguage();

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">{t('Loading…')}</span>
        </div>
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to={routeForPageId(SIGN_IN_PAGE_ID)} replace state={{ from: location }} />;
  if (!roles.includes(user.role)) return <Navigate to="/403" replace />;
  return <Outlet />;
}
